import Model, { attr, belongsTo, hasMany } from '@ember-data/model';

export default class KineticIssuedMaterial extends Model {
  @attr('string') partNumber;
  @attr('number') assemblySequence;
  @attr('number') materialSequence;
  @attr('number') relatedOperation;
  @attr('number') requiredQuantity;
  @attr('number') issuedQuantity;
  @attr('boolean', { defaultValue: false }) issuedComplete;
  @attr('number') quantityPer;

  @belongsTo('kinetic-job-assembly', { async: false, inverse: 'issuedMaterials' }) assembly;
  @hasMany('kinetic-material-quantity', { async: false, inverse: null, embedded: true }) issuedQuantities;
}
